module.exports = __webpack_public_path__ + "files/7ad73dfd9d9a420defd44e73db6d963b.svg";